import { FC, useState } from 'react';
import Modal from 'common/components/ModalComponent';
import sendOtp from 'common/api/otp';
import { signOut } from 'common/api/user';
import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';
import PhoneNumberForm from './PhoneNumberForm';
import OtpForm from './OtpForm';
import { validatePhoneNumber } from './utils';

type PhoneNumberVerificationProps = {
  isSessionActive: boolean;
  onCloseModalPresent?: boolean;
  onCloseModal?: () => void;
  routePath: string;
};

export type PhoneNumberState = {
  phoneNumber: string;
  isLoading: boolean;
  isOtpSent: boolean;
  error: string | null;
};

const PhoneNumberVerification: FC<PhoneNumberVerificationProps> = ({
  isSessionActive,
  onCloseModalPresent,
  onCloseModal,
  routePath,
}) => {
  const initialState = {
    phoneNumber: '',
    isLoading: false,
    isOtpSent: isSessionActive,
    error: null,
  };

  const [phoneNumberState, setPhoneNumberState] = useState<PhoneNumberState>(initialState);
  const { phoneNumber, isOtpSent } = phoneNumberState;

  const onPhoneNumberSubmit = (event?: React.FormEvent<HTMLFormElement> | undefined) => {
    if (event) event.preventDefault();
    const errorMessage = validatePhoneNumber(phoneNumber);

    if (errorMessage) return setPhoneNumberState((prevState) => ({ ...prevState, error: errorMessage }));

    setPhoneNumberState((prevState) => ({ ...prevState, isLoading: true }));
    sendOtp(phoneNumber)
      .then((res) => {
        if (!res.data.status) {
          reactToastify(res.data.message, TOASTIFY_TYPES.ERROR);
        } else {
          setPhoneNumberState((prevState) => ({ ...prevState, isOtpSent: true }));
          reactToastify(res.data.message, TOASTIFY_TYPES.SUCCESS);
        }
      })
      .finally(() => setPhoneNumberState((prevState) => ({ ...prevState, isLoading: false })));
  };

  const onResendOtp = () => {
    if (!phoneNumber) {
      setPhoneNumberState((prevState) => ({ ...prevState, isOtpSent: false }));
      return;
    }
    onPhoneNumberSubmit();
  };

  return (
    <Modal size="md" onClose={onCloseModalPresent ? onCloseModal : signOut} className="mobile-verification">
      {isOtpSent ? (
        <OtpForm phoneNumber={phoneNumber} onResendOtp={onResendOtp} routePath={routePath} />
      ) : (
        <PhoneNumberForm
          phoneNumberState={phoneNumberState}
          setPhoneNumberState={setPhoneNumberState}
          onPhoneNumberSubmit={onPhoneNumberSubmit}
        />
      )}
    </Modal>
  );
};

export default PhoneNumberVerification;
